module.exports = __webpack_public_path__ + "img/lijichou2.51151aa4.png";